import { render } from "./ca.vue?vue&type=template&id=70319fce"
import script from "./ca.vue?vue&type=script&lang=js"
export * from "./ca.vue?vue&type=script&lang=js"

import "./ca.vue?vue&type=style&index=0&id=70319fce&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/cookieAuthority/theme/ca.vue'],['render',render],['__file',"ca.vue"]])

export default __exports__